import React from 'react';
type SectionHeadingProps = {
  label: string;
  title: React.ReactNode;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
};
export function SectionHeading({
  label,
  title,
  description,
  tone = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={[align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl', className].join(' ')} data-id="element-343" data-mp="3k204hcqmli7u">
      <div className={['flex items-center gap-3', align === 'center' ? 'justify-center' : ''].join(' ')} data-id="element-344" data-mp="gjgk0we6vgnl">
        <span className="h-px w-8 bg-brand-500" aria-hidden="true" data-id="element-345" data-mp="1utuk1uul8in" />
        <span className={['text-[11px] font-semibold uppercase tracking-[0.28em]', dark ? 'text-brand-400' : 'text-brand-600'].join(' ')} data-id="element-346" data-mp="1shgw0w4hkbe">
          {label}
        </span>
      </div>
      <h2 className={['mt-5 font-heading text-[2rem] font-extrabold uppercase leading-[1.05] tracking-[-0.02em] sm:text-5xl', dark ? 'text-white' : 'text-navy'].join(' ')} data-id="element-347" data-mp="zahizkfb7c75">
        {title}
      </h2>
      {description && <p className={['mt-6 text-base leading-relaxed sm:text-lg', dark ? 'text-white/60' : 'text-mist-600', align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-xl'].join(' ')} data-id="element-348" data-mp="1o91ibl7zlqjm">
          {description}
        </p>}
    </div>;
}